import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/presse/Presse.css");
;
import(/* webpackMode: "eager", webpackExports: ["Banner"] */ "/vercel/path0/src/common/Banner.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/common/StickyWidget.js");
